import addError from '../../../utils/error.jsx';

export function request(id, duration) {
    id = parseInt(id, 10);

    return {
        type: 'CUSTOMERS_REALITY_CHECK_REQUEST',
        duration,
        id
    };
}

export function error(id, errors) {
    id = parseInt(id, 10);

    addError(errors);

    return {
        type: 'CUSTOMERS_REALITY_CHECK_ERROR',
        errors,
        id
    };
}

export function finish(id, customer) {
    return {
        type: 'CUSTOMERS_REALITY_CHECK_FINISH',
        customer,
        id
    };
}

export function clear() {
    return {
        type: 'CUSTOMERS_REALITY_CHECK_CLEAR'
    };
}
